import React, { useEffect, useState } from "react";

/** Components */
import {
  ButtonGroup,
  Button,
  Tooltip,
  Collapse,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  TextField,
  Tabs,
  Tab,
} from "@mui/material";

import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Functions and Api */
import { setHeaderTitle } from "../../../store/layoutSlide";
import { getPrepaid, showPrepaid, notiPrepaid, getCustomerByID, getPrepaidNoti } from "../../../services/api";
import { convertToMoneyWordEN, numberToStringVN } from "../../../services/libService";

/** Hook */
import { useDispatch } from "react-redux";
import moment from "moment";
import { useSnackbar } from "notistack";
import { fitToColumn } from "../../../services/libService";
import * as XLSX from "xlsx";

/** Init table */
const tblHeader = [
  "STT",
  "Khách hàng",
  "Tiền tệ",
  "Tổng tiền đã xuất hoá đơn (" + new Date().getFullYear().toString() + ")",
  "Tổng tiền trả trước đã tính số dư đầu kỳ ( " + new Date().getFullYear().toString() + ")",
  "Tổng tiền còn lại",
];

const tabInfor = [
  { id: 0, title: "Statement of Account" },
  { id: 1, title: "Prepaid Notification" },
];

const Prepaid = () => {
  /** State */
  // handle open dialog
  const [open, setOpen] = useState(false);
  // table data
  const [data, setData] = useState(null);
  const [selectedRow, setSelectedRow] = useState(false);

  /** Hook */
  const dispatch = useDispatch();

  /** Init header and data */
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN KHÁCH HÀNG TRẢ TRƯỚC"));

    getPrepaid().then((res) => {
      if (res.code === 200) setData(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Funtions  */
  const handleRowClick = (row) => {
    setSelectedRow(row);
  };
  return (
    <div>
      {/* Header */}
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {/* Filter */}
      <Collapse in={open}></Collapse>

      {/* Main Table */}
      <div style={{ display: "flex" }}>
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {tblHeader.map((item, id) => (
                  <TableCell key={id} style={{ border: "0.5px solid lightgray" }}>
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.map((row, id) => (
                  <TableRow key={id} hover style={{ cursor: "pointer" }} onClick={(e) => handleRowClick(row)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{id + 1} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                      {row.customer}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.currency} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                      {row.total?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                      {row.prepaid?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                      {(row.prepaid - row.total)?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP")}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <DetailStatement data={selectedRow} onClose={() => setSelectedRow(null)} />
    </div>
  );
};
export default Prepaid;

/** Statement of Account */

/** Init Statement Table  */
const tblStatementHeader = ["No", "Date", "Ref.No", "Currency", "Amount", "Prepaid ", "Remaining"];
const tblNotiHeader = ["No", "Issue Date", "Expired Date", "Ref.No", "Currency", "Amount", "User Name"];

const DetailStatement = ({ data, onClose }) => {
  /** State */
  const [cusDetail, setCusDetail] = useState(null);
  const [tab, setTab] = useState(0);
  const [input, setInput] = useState({
    open: false,
    code: null,
    remaining: 0,
    amount: 0,
    exp_date: null,
    currency: null,
    customer_id: null,
  });

  const [noti, setNoti] = useState(null);

  /** Set Infor for Detail */
  useEffect(() => {
    if (data?.customer_id != null) {
      showPrepaid(data.customer_id).then((res) => {
        if (res.code === 200) {
          /** Format data to display */
          var newData = res.data;
          // for (var i = 0; i < res.data.length; i++)
          //   if (i === 0) {
          //     newData[i].remaining = newData[i].prepaid - newData[i].total;
          //   } else {
          //     newData[i].remaining = newData[i].prepaid - newData[i].total + newData[i - 1].remaining;
          //   }

          for (let i = 0; i < newData.length; i++) {
            let current = newData[i];
            let previousRemaining = i > 0 ? newData[i - 1].remaining : 0;

            let remaining = current.prepaid - current.total + previousRemaining;

            // Format theo loại tiền tệ
            if (input.currency === "USD") {
              current.remaining = Number(remaining.toFixed(2));
            } else if (input.currency === "VND") {
              current.remaining = Math.round(remaining);
            } else {
              // Default fallback nếu không xác định được loại tiền
              current.remaining = Number(remaining);
            }
          }
          setInput((prev) => ({ ...prev, remaining: newData[newData.length - 1].remaining }));
          setCusDetail(newData);
        }
      });

      // Init input
      setInput((prev) => ({ ...prev, currency: data.currency, customer_id: data.customer_id }));
    }
  }, [data]);

  const exportExcel = () => {
    const arrData = cusDetail.map((item, index) => ({
      // làm thế này để xác định những cột nào định dạng string trong file csv
      No: index + 1,
      Date: moment(item.idate).format("DD/MM/YYYY"),
      "Ref.No": item.code,
      Currency: item.currency,
      "Tổng giá trị xuất hoá đơn": index > 0 ? item.total : 0,
      "Tổng giá trị trả trước": index > 0 ? item.prepaid : 0,
      "Tổng giá trị còn lại": item.remaining,
    }));
    const worksheet = XLSX.utils.json_to_sheet(arrData);
    worksheet["!cols"] = fitToColumn(arrData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFileXLSX(workbook, `Prepaid.xlsx`);
  };

  const handleNotiPreview = () => {
    // setInput((prev) => ({ ...prev, open: true }))
    getCustomerByID(data.customer_id).then((res) =>
      setInput((prev) => ({
        ...prev,
        customer_name: res.data.name,
        currency: res.data.bact?.currency,
        act_holder: res.data.bact?.act_holder,
        act_number: res.data.bact?.act_number,
        bank_code: res.data.bact?.bank_code,
        swift_code: res.data.bact?.swift_code,

        inwords: input.currency === "VND" ? numberToStringVN(input.amount) : convertToMoneyWordEN(input.amount),
        open: true,
      }))
    );
  };

  return (
    <Dialog open={Boolean(data)} onClose={onClose} maxWidth={"sx"} fullWidth>
      <DialogTitle style={{ backgroundColor: "#0288D1", color: "white" }} align="center">
        THÔNG TIN KHÁCH HÀNG TRẢ TRƯỚC
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Tabs value={tab} style={{ paddingBottom: 10 }}>
          {tabInfor.map((item, id) => (
            <Tab
              onClick={() => {
                setTab(id);
                if (id === 1)
                  getPrepaidNoti({ customer_id: data.customer_id, per_page: 50 }).then((res) => {
                    if (res.code === 200) setNoti(res.data.data);
                  });
                else setNoti(null);
              }}
              label={item.title}
            />
          ))}
        </Tabs>
        <div hidden={tab !== 0}>
          {Boolean(data) && (
            <>
              <Typography style={{ marginLeft: 10, fontSize: 14 }}>Customer: {data.customer}</Typography>
              <Typography style={{ marginLeft: 10, fontSize: 14 }}>Date: {moment().format("DD/MM/YYYY")}</Typography>
              <Grid container spacing={2} style={{ marginTop: 2 }}>
                <Grid item xs={12}>
                  <div style={{ display: "flex" }}>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      label="Số thông báo"
                      value={input.code || ""}
                      style={{ margin: "5px" }}
                      onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))}
                    />
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      label="Số tiền trả trước"
                      value={input.amount || ""}
                      style={{ margin: "5px" }}
                      onChange={(e) => setInput((prev) => ({ ...prev, amount: e.target.value }))}
                    />
                    <CustomDatePicker label={"Ngày đến hạn"} value={input?.exp_date} onChange={(value) => setInput((prev) => ({ ...prev, exp_date: value }))} sx={{ margin: "5px" }} />
                    <Button variant="outlined" style={{ margin: "5px", height: 40, fontSize: 10 }} onClick={() => handleNotiPreview()}>
                      Gửi thông báo
                    </Button>
                    <Button variant="outlined" style={{ margin: "5px", height: 40, fontSize: 10, display: Boolean(cusDetail?.length) ? "" : "none" }} onClick={exportExcel}>
                      Xuất excel
                    </Button>
                  </div>
                </Grid>
              </Grid>

              <hr />
              <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {tblStatementHeader.map((item, id) => (
                        <TableCell key={id} style={{ border: "0.5px solid lightgray" }}>
                          {item}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cusDetail &&
                      cusDetail.map((row, id) => (
                        <TableRow key={id}>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{id + 1} </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {moment(row.idate).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code} </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{row.currency} </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                            {id !== 0 ? (row.total !== 0 ? row.total?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP") : "") : ""}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                            {id !== 0 ? (row.prepaid !== 0 ? row.prepaid?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP") : "") : ""}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                            {row.remaining?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP")}
                          </TableCell>
                        </TableRow>
                      ))}
                    {cusDetail && (
                      <TableRow>
                        <TableCell colSpan={6} style={{ border: "0.5px solid lightgray" }}>
                          <b>SUBTOTAL</b>
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                          <b>{cusDetail[cusDetail.length - 1].remaining.toLocaleString(cusDetail[0].currency === "VND" ? "de-DE" : "ja-JP")}</b>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <NotiPreview data={input} onClose={() => setInput((prev) => ({ ...prev, open: false }))} />
            </>
          )}
        </div>
        <div hidden={tab !== 1}>
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {tblNotiHeader.map((item, id) => (
                    <TableCell key={id} style={{ border: "0.5px solid lightgray" }}>
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {noti &&
                  noti.map((row, id) => (
                    <TableRow key={id}>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{id + 1} </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(row.valid_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(row.exp_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code} </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.currency} </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                        {row.amount?.toLocaleString(row.currency === "VND" ? "de-DE" : "ja-JP")}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                        {row.username}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const NotiPreview = ({ data, onClose }) => {
  /** State */

  const [input, setInput] = useState({
    valid_date: moment().format("YYYY-MM-DD"),
    product_name: "JET A-1",
    description: "PREPAYMENT FOR REFUELLING SERVICE OF JET A-1",
  });

  /** Get Information of customer */
  useEffect(() => {
    setInput((prev) => ({
      ...prev,
      code: data.code,
      remaining: data.remaining,
      amount: parseFloat(data.amount),
      exp_date: data.exp_date,
      customer_id: data.customer_id,
      customer_name: data.customer_name,
      currency: data.currency,
      act_holder: data.act_holder,
      act_number: data.act_number,
      bank_code: data.bank_code,
      swift_code: data.swift_code,
      inwords: data.inwords,
    }));
  }, [data.act_holder, data.act_number, data.amount, data.bank_code, data.code, data.currency, data.customer_id, data.customer_name, data.exp_date, data.inwords, data.remaining, data.swift_code]);

  /** Hook */
  const { enqueueSnackbar } = useSnackbar();

  /** Send nofity */
  const handleNotiPrepaid = () => {
    notiPrepaid(input).then((res) => {
      if (res.code === 200) {
        enqueueSnackbar(res.message);
        onClose();
      }
    });
  };

  return (
    <Dialog open={data.open} onClose={onClose} maxWidth={"md"} fullWidth>
      <DialogTitle style={{ backgroundColor: "#0288D1", color: "white" }} align="center">
        PREPAYMENT ADVICE
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        {Boolean(data) && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={8} />
              <Grid item xs={4}>
                <Typography style={{ marginLeft: 10, fontSize: 14 }}>No: {input?.code} </Typography>
                <Typography style={{ marginLeft: 10, fontSize: 14 }}>Date: {moment(input.valid_date).format("DD/MM/YYYY")}</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography style={{ marginLeft: 10, fontSize: 14 }}>From: {input?.act_holder}</Typography>
                <Typography style={{ marginLeft: 10, fontSize: 14 }}>To: {input?.customer_name}</Typography>
                <Typography style={{ marginLeft: 10, fontSize: 14 }}>Product: {input?.product_name} </Typography>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
            <Table style={{ marginTop: 10, marginBottom: 10 }}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}>Description</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Due date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={2}>
                    <TextField style={{ width: "100%" }} value={input?.description} onChange={(e) => setInput((prev) => ({ ...prev, description: e.target.value }))}></TextField>
                  </TableCell>
                  <TableCell>
                    {input?.currency} {input?.amount?.toLocaleString(data.currency === "VND" ? "de-DE" : "ja-JP")}
                  </TableCell>
                  <TableCell>{input.exp_date != null ? moment(input?.exp_date).format("DD/MM/YYYY") : ""}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={4}>In words: {input?.inwords} </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Typography style={{ marginLeft: 10, fontSize: 14, fontWeight: "bold" }}>PAYMENT INSTRUCTIONS: </Typography>
            <Typography style={{ marginLeft: 10, fontSize: 14 }}>Please remit the above amount upon the receipt of the scanned Invoice as below: </Typography>
            <Typography style={{ marginLeft: 10, fontSize: 14 }}>- Name’s account: {input?.act_holder} </Typography>
            <Typography style={{ marginLeft: 10, fontSize: 14 }}>- Account No: {input?.act_number} </Typography>
            <Typography style={{ marginLeft: 10, fontSize: 14 }}>- Bank: {input?.bank_code} </Typography>
            <Typography style={{ marginLeft: 10, fontSize: 14 }}>- Swift code: {input?.swift_code} </Typography>
            <Typography style={{ marginLeft: 10, fontSize: 14 }}>- Address: Floor 6th, Mipec Tower, No. 229 Tay Son Str., Dong Da Dist., Hanoi, Vietnam </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onClose}>
          Nhập lại
        </Button>
        <Button variant="outlined" color="success" onClick={() => handleNotiPrepaid()}>
          Xác nhận
        </Button>
      </DialogActions>
    </Dialog>
  );
};
